import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import { getContentById } from "../../actions/course";
import { getProfileById } from "../../actions/profile";
import { getToursById } from "../../actions/vrtour";
import {
  getJobPostsById,
  apply,
  applyIME,
  applyIMEResume,
  deleteApplication,
  clearJobs,
} from "../../actions/job";

import MentorMiniStream from "../layout/Mentors/MentorMiniStream";
import LoggedInNavRed from "../layout/IME/LoggedInNavRed";

import JobPostItem from "../layout/Employers/JobPostItem";
import JobMiniStream from "../layout/Employers/JobMiniStream";
import VRTourMiniVideo from "../layout/Employers/VRTourMiniVideo";
import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import UploadResume from "../layout/IME/UploadResume";
import AppliedSuccess from "../layout/IME/AppliedSuccess";
import Applied from "../layout/IME/Applied";
import ApplicationRemoved from "../layout/IME/ApplicationRemoved";

const Content = ({
  match,
  auth: { user },
  course: { course },
  vrtour: { tours },
  profile: { profile },
  job: { jobs, applicant, comments, jobloading },
  isAuthenticated,
  getProfileById,
  getContentById,
  getToursById,
  getJobPostsById,
  apply,
  applyIME,
  applyIMEResume,
  deleteApplication,
  clearJobs,
}) => {
  useEffect(() => {
    getProfileById(match.params.channelid);
    getContentById(match.params.channelid);
    getToursById(match.params.channelid);
    getJobPostsById(match.params.channelid);
  }, [getProfileById, getContentById, getToursById, getJobPostsById]);

  const [Job, setshowJob] = useState({
    _id: "",
    channelid: "",
    companyname: "",
    avatar: "",
    jobtitle: "",
    location: {},
    keywords: [],
    jobdescription: "",
    jobsummary: "",
    environment: "",
    employmenttype: "",
    salary: 0,
    responsibilities: [],
    qualifications: [],
    benefits: [],
    comments: [],
    vrtour: "",
    jobstream: "",
    date: "",
  });
  const [attachmentFile, setAttachmentFile] = useState({
    file: "",
    email: "",
    docType: "docx",
  });
  const [attachmentDataFile, setAttachmentDataFile] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);
  const [addAttachment, setShowAddAttachment] = useState(false);

  const jobId = Job._id;

  const jobChannelId = Job.channelid;

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.role === "innovator") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {profile && profile.role === "mentor" && (
        <div>
          {isAuthenticated && <LoggedInNavRed />}
          {!isAuthenticated && <LoggedOutNav />}
          <div className="flex-all-content-fixed">
            <section className="banner-hero-alt">
              <div className="banner-section-name">
                <h1 className="large-font white">Live Streams</h1>
                {profile.user === user.user && (
                  <div className="post-action-button">
                    <Link to={`/liveonime/mentors/${profile.channelid}/live`}>
                      <div className="banner-action-items red">
                        <div className="action-button">
                          <i className="fas fa-video fa-lg action-icon-video red"></i>
                        </div>
                        <p className="action-text">Go Live</p>
                      </div>
                    </Link>
                  </div>
                )}
              </div>
            </section>
            <section className="main-body">
              {/* {course ? (
                <div className="created-content">
                  <div>Mentor Streams</div>
                </div>
              ) : ( */}
              <p className="empty-content-alt red">No Content</p>
              {/* )} */}
            </section>
            <section className="banner-hero-alt">
              <div className="banner-section-name">
                <h1 className="large-font white">Courses</h1>
                {profile.user === user.user && (
                  <Link to={`/${user && user.channelid}/create_course`}>
                    <div className="post-action-button">
                      <div className="banner-action-items red">
                        <div className="action-button">
                          <i className="fas fa-graduation-cap fa-lg action-icon-video red"></i>
                        </div>
                        <p className="action-text">Create New Course</p>
                      </div>
                    </div>
                  </Link>
                )}
              </div>
            </section>
            <section className="main-body">
              {course ? (
                <div className="created-content">
                  {course.courses &&
                    course.courses.map((course) => {
                      return (
                        <div className="content-container">
                          <div className="stream-result">
                            <MentorMiniStream course={course} />
                            {profile.user === user.user && (
                              <div className="posts-buttons-container">
                                <button
                                  type="submit"
                                  className="post-button background-dark-black red"
                                >
                                  <i className="fas fa-edit red mx-5"></i>Edit
                                </button>
                                <button
                                  type="submit"
                                  className="post-button background-red"
                                >
                                  <i className="fas fa-times mx-5"></i>Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <p className="empty-content-alt red">No Content</p>
              )}
            </section>
          </div>
        </div>
      )}
      {profile && profile.role === "employer" && (
        <div>
          {applicant && applicant.msg === "Application Removed" && (
            <ApplicationRemoved clearJobs={clearJobs} />
          )}
          {!isAuthenticated &&
            applicant.email == attachmentFile.email &&
            applicant.email !== undefined && (
              <AppliedSuccess
                isAuthenticated={isAuthenticated}
                user={user}
                applicant={applicant}
                attachmentFile={attachmentFile}
                setAttachmentFile={setAttachmentFile}
                clearJobs={clearJobs}
              />
            )}
          {isAuthenticated &&
            applicant.channelid == user.channelid &&
            applicant.channelid !== undefined && (
              <AppliedSuccess
                isAuthenticated={isAuthenticated}
                user={user}
                applicant={applicant}
                attachmentFile={attachmentFile}
                setAttachmentFile={setAttachmentFile}
                clearJobs={clearJobs}
              />
            )}
          {applicant &&
            applicant.msg &&
            applicant.msg ===
              "Oops! Looks like you have already applied to this position. Would you like to withdraw your pending application?" && (
              <Applied
                isAuthenticated={isAuthenticated}
                user={user}
                applicant={applicant}
                attachmentFile={attachmentFile}
                setAttachmentFile={setAttachmentFile}
                clearJobs={clearJobs}
                jobId={jobId}
                jobChannelId={jobChannelId}
                deleteApplication={deleteApplication}
              />
            )}
          {addAttachment && (
            <UploadResume
              setShowAddAttachment={setShowAddAttachment}
              setAttachmentFile={setAttachmentFile}
              attachmentFile={attachmentFile}
              setAttachmentDataFile={setAttachmentDataFile}
              attachmentDataFile={attachmentDataFile}
              setAttachments={setAttachments}
              attachments={attachments}
              setFiles={setFiles}
              files={files}
              Job={Job}
              isAuthenticated={isAuthenticated}
              user={user}
              applyIMEResume={applyIMEResume}
              jobId={jobId}
              jobChannelId={jobChannelId}
            />
          )}
          {!isAuthenticated && <LoggedOutNav />}
          {isAuthenticated && <LoggedInNavBlue />}
          <div className="flex-all-content-fixed">
            <section className="banner-hero-alt">
              <div className="banner-section-name">
                <h1 className="large-font white">Job Posts</h1>
                <div className="post-action-button">
                  <div className="banner-action-items blue">
                    <div className="banner-action-button">
                      <i className="fas fa-briefcase fa-lg action-icon-case blue"></i>
                    </div>
                    <p className="action-text">Current open job posts</p>
                  </div>
                </div>
                {profile.user === user.user && (
                  <Link to={`/${user && user.channelid}/create_job_post`}>
                    <div className="post-action-button">
                      <div className="banner-action-items blue">
                        <div className="banner-action-button">
                          <i className="fas fa-pen fa-lg action-icon-case blue"></i>
                        </div>
                        <p className="action-text">Create new job post</p>
                      </div>
                    </div>
                  </Link>
                )}
              </div>
            </section>
            <section className="main-body">
              {jobs.length > 0 ? (
                <div className="created-content">
                  {jobs &&
                    jobs.map((jobpostitem) => {
                      return (
                        <div className="content-container">
                          <JobPostItem
                            jobpostitem={jobpostitem}
                            key={jobpostitem._id}
                            setShowAddAttachment={setShowAddAttachment}
                          />
                        </div>
                      );
                    })}
                </div>
              ) : (
                <p className="empty-content-alt blue">No Content</p>
              )}
            </section>
            <section className="banner-hero-alt">
              <div className="banner-section-name">
                <h1 className="large-font white">Job Streams</h1>
                {profile.user === user.user && (
                  <div className="post-action-button">
                    <Link to={`/liveonime/employers/${profile.channelid}/live`}>
                      <div className="banner-action-items blue">
                        <div className="action-button">
                          <i className="fas fa-video fa-lg action-icon-video blue"></i>
                        </div>
                        <p className="action-text">Go Live</p>
                      </div>
                    </Link>
                  </div>
                )}
              </div>
            </section>
            <section className="main-body">
              <div className="created-content">
                <div className="content-container">
                  <div className="stream-result">
                    <JobMiniStream />
                    {profile.user === user.user && (
                      <div className="posts-buttons-container">
                        <button
                          type="submit"
                          className="post-button background-red"
                        >
                          <i className="fas fa-times mx-5"></i>Delete
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
            <section className="banner-hero-alt">
              <div className="banner-section-name">
                <h1 className="large-font white">VR Tours</h1>
                {profile.user === user.user && (
                  <Link to={`/${user && user.channelid}/create_vrtour`}>
                    <div className="post-action-button">
                      <div className="banner-action-items blue">
                        <div className="action-button">
                          <i className="fas fa-street-view fa-lg action-icon-video blue"></i>
                        </div>
                        <p className="action-text">Create New Tour</p>
                      </div>
                    </div>
                  </Link>
                )}
              </div>
            </section>
            <section className="main-body">
              {tours && tours.length > 0 ? (
                <div className="created-content">
                  {tours &&
                    tours.map((vrtours) => {
                      return (
                        <div className="content-container">
                          <div className="stream-result">
                            <VRTourMiniVideo vrtours={vrtours} />
                            {profile.user === user.user && (
                              <div className="posts-buttons-container">
                                <button
                                  type="submit"
                                  className="post-button background-blue"
                                >
                                  <i className="far fa-file-alt mx-5"></i>Edit
                                </button>
                                <button
                                  type="submit"
                                  className="post-button background-red"
                                >
                                  <i className="fas fa-times mx-5"></i>Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <p className="empty-content-alt blue">No Content</p>
              )}
            </section>
            {!isAuthenticated &&
              attachmentFile.file !== "" &&
              attachmentFile.email !== "" &&
              !addAttachment && (
                <div className="submit-changes-dark">
                  <button
                    className="submit-changes-button background-blue white"
                    onClick={() => {
                      apply(attachmentFile, files, jobChannelId, jobId);
                      setAttachmentDataFile("");
                      setFiles([]);
                      setAttachments([]);
                    }}
                  >
                    Apply
                  </button>
                </div>
              )}
            {isAuthenticated &&
              attachmentFile.file !== "" &&
              !addAttachment && (
                <div className="submit-changes-dark">
                  <button
                    className="submit-changes-button background-blue white"
                    onClick={() => {
                      applyIME(attachmentFile, files, jobChannelId, jobId);
                      setAttachmentDataFile("");
                      setFiles([]);
                      setAttachments([]);
                    }}
                  >
                    Apply
                  </button>
                </div>
              )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

Content.propTypes = {
  getProfileById: PropTypes.func.isRequired,
  getContentById: PropTypes.func.isRequired,
  getToursById: PropTypes.func.isRequired,
  getJobPostsById: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  course: state.course,
  job: state.job,
  vrtour: state.vrtour,
  profile: state.profile,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  getContentById,
  getToursById,
  getJobPostsById,
})(Content);
